var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from "@tanstack/react-query";
import { constant, exact, nonEmptyString } from "decoders";
import { EXTENSION_ID } from "~/client/constants";
import { getUserId } from "~/client/storage";
import config from "~/config";
const heartbeatResponse = exact({
    type: constant("PONG"),
    sender: constant("service-worker"),
    payload: exact({ extensionVersion: nonEmptyString }),
});
const useExtensionHeartbeat = () => {
    const userId = getUserId();
    return useQuery({
        enabled: userId !== null,
        queryKey: ["extension-heartbeat", userId],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            if (!((_a = window.chrome) === null || _a === void 0 ? void 0 : _a.runtime)) {
                throw new Error("Extension helpers do not exist.");
            }
            const response = yield window.chrome.runtime.sendMessage(EXTENSION_ID, {
                type: "PING",
                sender: "web-app",
                payload: {
                    userId,
                },
            });
            const { payload: { extensionVersion }, } = heartbeatResponse.verify(response);
            return { version: extensionVersion };
        }),
        refetchInterval: config.EXTENSION_HEARTBEAT_INTERVAL_MILLISECONDS,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: true,
    });
};
export default useExtensionHeartbeat;
